/* 
 * ZoomTransition.js
 * Created on 7-apr-2017
 * @author Swen Meeuwes for &ranj
 */

import AnimationOptions from "../AnimationOptions";
import AnimationFactory from "../AnimationFactory";

export default class ZoomTransition {
    constructor(type) {
        this.type = type;
    };

    animate(screenNavigator, screen, animationOptions) {
        return new Promise(function (resolve, reject) {
            // If no animation options are specified, use the default animation options
            if (animationOptions === undefined)
                animationOptions = new AnimationOptions();

            var beginState = { scaleX: 0, scaleY: 0 };
            var endState = { scaleX: 0, scaleY: 0 };

            switch (this.type) {
                case AnimationFactory.ZOOM_IN:
                    endState.scaleX = endState.scaleY = 1;
                    break;
                case AnimationFactory.ZOOM_OUT:
                    beginState.scaleX = beginState.scaleY = 1;
                    break;
                case AnimationFactory.ZOOM_SLIGHTLY_IN:
                    endState.scaleX = endState.scaleY = 0.78;
                    break;
                case AnimationFactory.ZOOM_SLIGHTLY_OUT:
                    beginState.scaleX = beginState.scaleY = 1;
                    endState.scaleX = endState.scaleY = 0.78;
                    break;
                default:
                    // Log warning
                    break;
            }

            // Set the screen to its begin state
            screen.set(beginState);

            // Execute the tween with the given animation options
            createjs.Tween
                .get(screen)
                .wait(animationOptions.delay)
                .to(endState, animationOptions.duration, animationOptions.ease)
                .call(function () {
                    // Handle callbacks in animation options
                    if (animationOptions.callbacks)
                        for (var i = 0; i < animationOptions.callbacks.length; i++) {
                            animationOptions.callbacks[i].call(this);
                        }
                    resolve();
                }.bind(this));
        }.bind(this));
    };
}